var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("ListingWrapperLoadingState")
    : _c(
        "div",
        { staticClass: "listing-wrapper" },
        [
          _vm.title
            ? _c("div", { staticClass: "listing-wrapper__header" }, [
                _c(
                  "div",
                  [
                    _c("h1", { staticClass: "typographies-heading-h1" }, [
                      _vm._v(_vm._s(_vm.title))
                    ]),
                    _vm._v(" "),
                    !!_vm.tabs.length
                      ? _c("TabsNav", {
                          attrs: { tabs: _vm.tabs, activeTab: _vm.activeTab },
                          on: {
                            "tab-clicked": function(tab) {
                              return _vm.$emit("update:activeTab", tab)
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "listing-wrapper__header-actions" },
                  [_vm._t("listingActions")],
                  2
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "listing-wrapper-settings-header__container" },
            [
              !!_vm.pagination
                ? _c("Paginator", {
                    staticClass: "listing-wrapper-settings-header__pagination",
                    attrs: { pagination: _vm.pagination },
                    on: { "pagination:update": _vm.updatePaginationOffset }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm._t("settings")
            ],
            2
          ),
          _vm._v(" "),
          _vm._t("table")
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }